export default function ChatMessage({ role, text }) {
  const isUser = role === 'user';

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: isUser ? 'flex-end' : 'flex-start',
      }}
    >
      <div
        style={{
          maxWidth: '72%',
          padding: '10px 14px',
          borderRadius: 14,
          color: '#fff',
          lineHeight: '24px',
          fontSize: 16,
          fontFamily:
            'Inter, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Helvetica, Arial, sans-serif',
          background: isUser
            ? 'linear-gradient(0deg, rgba(255,255,255,0.14), rgba(255,255,255,0.06))'
            : 'rgba(255,255,255,0.08)',
          border: '1px solid rgba(255,255,255,0.12)',
          boxShadow: '-2px 0 2px rgba(255, 255, 255, 0.3), 2px 0 2px rgba(255, 255, 255, 0.3)',
          backdropFilter: 'blur(3px)',
          WebkitBackdropFilter: 'blur(3px)',
          textAlign: 'left',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          marginLeft: '2px',
          marginRight: '2px'
        }}
      >
        {text}
      </div>
    </div>
  );
}